import { formatFileSize } from '@/mocks/driveFiles';
import type { DriveItem } from '@/mocks/driveFiles';

interface DeleteDialogProps {
  item: DriveItem;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function DeleteDialog({ item, onConfirm, onCancel }: DeleteDialogProps) {
  const isFolder = item.type === 'folder';
  const isInTrash = !!item.deletedAt;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onCancel}>
      <div
        className="bg-background-50 rounded-xl p-6 max-w-sm w-full border border-background-200"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 mb-4">
          <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-50 flex-shrink-0">
            <i className="ri-alert-line text-xl text-accent-500"></i>
          </span>
          <div>
            <h3 className="text-base font-semibold text-foreground-900">
              {isInTrash ? '영구 삭제' : isFolder ? '폴더 삭제' : '파일 삭제'}
            </h3>
          </div>
        </div>

        <div className="mb-1 p-3 bg-background-100 rounded-lg border border-background-200">
          <div className="flex items-center gap-2.5">
            <span className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${
              isFolder ? 'bg-accent-50' : 'bg-background-200'
            }`}>
              <i className={`${isFolder ? 'ri-folder-3-fill text-accent-500' : 'ri-file-3-line text-foreground-600'} text-base`}></i>
            </span>
            <div className="min-w-0">
              <p className="text-sm font-medium text-foreground-800 truncate">{item.name}</p>
              <p className="text-xs text-foreground-500">
                {isFolder ? '폴더' : formatFileSize(item.size ?? 0)}
              </p>
            </div>
          </div>
        </div>

        <p className="text-sm text-foreground-600 mb-5">
          {isInTrash
            ? '영구 삭제하면 복구할 수 없습니다. 정말 삭제하시겠습니까?'
            : isFolder
              ? '폴더를 휴지통으로 이동하면 포함된 모든 파일과 하위 폴더도 함께 이동됩니다.'
              : '파일을 휴지통으로 이동합니다.'}{' '}
          {!isInTrash && '30일 후 자동으로 삭제됩니다.'}
        </p>

        <div className="flex justify-end gap-2">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium rounded-lg border border-background-300 text-foreground-700 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            취소
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium rounded-lg bg-accent-500 text-white hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            {isInTrash ? '영구 삭제' : '휴지통으로 이동'}
          </button>
        </div>
      </div>
    </div>
  );
}